import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { RoleBreadcrumb, RoleItemWidget } from '@/widgets/role-item-widget'

export const Route = createFileRoute('/_auth/users/role/$roleId')({
  staticData: {
    meta: {
      title: 'Карточка роли',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Карточка роли')} breadcrumbs={<RoleBreadcrumb />}>
      <RoleItemWidget mode="view" />
    </PageWrapper>
  )
}
